import { render, staticRenderFns } from "./headless-multiple-setting.vue?vue&type=template&id=24779b72&"
import script from "./headless-multiple-setting.vue?vue&type=script&lang=js&"
export * from "./headless-multiple-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports